import React, { Component } from "react";

import { colors } from "@atlaskit/theme";
import { AutoDismissFlag, FlagGroup } from "@atlaskit/flag";
import ErrorIcon from "@atlaskit/icon/glyph/error";
import WarningIcon from "@atlaskit/icon/glyph/warning";
import InfoIcon from "@atlaskit/icon/glyph/info";
import SuccessIcon from "@atlaskit/icon/glyph/check-circle";
// import Spinner from "@atlaskit/spinner";

// import { AccentColor, PrimaryColor } from "../../utils/consts";

import "./flags.css";

const flagAppearances = ["error", "info", "normal", "success", "warning"];
const color = {
  error: colors.R400,
  info: colors.N500,
  normal: colors.N0,
  success: colors.G400,
  warning: colors.Y200
};
// const flagIcons = {
//   _success: <SuccessIcon label="Info" />
// };
export default class Flags extends Component {
  getIcon = flag => {
    switch (flag.appearance) {
      case "error":
        return (
          <ErrorIcon primaryColor={color[flagAppearances[flag.appearance]]} />
        );
      case "info":
        return (
          <InfoIcon primaryColor={color[flagAppearances[flag.appearance]]} />
        );
      case "normal":
        return (
          <SuccessIcon primaryColor={color[flagAppearances[flag.appearance]]} />
        );
      case "success":
        return (
          <SuccessIcon primaryColor={color[flagAppearances[flag.appearance]]} />
        );
      case "warning":
        return (
          <WarningIcon primaryColor={color[flagAppearances[flag.appearance]]} />
        );
      default:
        return <SuccessIcon primaryColor={colors.G400} />;
    }
  };

  render() {
    return (
      <FlagGroup onDismissed={this.props.handleDismiss}>
        {this.props.flags.map((flag, i) => {
          // const appearance = flagAppearances[flag.appearance];
          return (
            <AutoDismissFlag
              id={i}
              icon={this.getIcon(flag)}
              key={i}
              title={flag.title}
              description={flag.description}
            />
          );
        })}
      </FlagGroup>
    );
  }
}
// {
//   <FlagGroup onDismiss={this.props.handleDismiss}>
//   {!!this.props.flags &&
//     this.props.flags.map((flag, i) => {
//       return (
//         <Flag
//           id={i}
//           key={i}
//           title={flag.title}
//           description={flag.description}
//           icon={() => this.getIcon(flag)}
//         />
//       );
//     })}
// </FlagGroup>}



// WEBPACK FOOTER //
// ./src/components/flags/Flags.js